import { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

interface ListItemProps {
  children: ReactNode;
}

export const ListItem = ({ children }: ListItemProps) => (
  <Flex
    _last={{
      marginBottom: 0,
    }}
    marginBottom="space-16"
  >
    <SunshineIcon
      aria-label="tick"
      color="grey.800"
      marginRight="space-16"
      name="tick"
      size="icon-16"
    />
    <Text variant="primary">{children}</Text>
  </Flex>
);
